import { useTranslation } from 'next-i18next'

import styles from '~/shared/styles/Input.module.css'

import { Icon } from './Icon'

interface Props {
  onBlur?: () => void
  onChange: (val: string) => void
  placeHolder: string
  value?: string | number
  fullWidth?: boolean
  disabled?: boolean
  hasError?: boolean
}
export default function NickNameField({
  value,
  onBlur,
  onChange,
  placeHolder,
  fullWidth,
  disabled,
  hasError,
}: Props): React.ReactElement {
  const { t } = useTranslation(['fields'])
  return (
    <div className={`${fullWidth && '!w-full'} relative mt-3 lg:w-5/6 h-10`}>
      <input
        autoFocus
        className={`text-black rounded-small shadow p-1 mr-2 outline-none w-full ${
          hasError ? 'border border-red' : 'border'
        } ${disabled ? 'bg-white/25 cursor-not-allowed' : ''}`}
        disabled={disabled}
        name="nickname"
        onBlur={onBlur}
        onChange={(evt) => onChange(evt.currentTarget.value)}
        onKeyDown={(evt) => {
          if (evt.key.toLowerCase() === 'enter') {
            onBlur?.()
          }
        }}
        placeholder={placeHolder}
        type="text"
        value={value}
      />
      <Icon
        alt={t('editInputFieldIcon')}
        className={`${styles['input-edit-icon']} top-1.5 !right-2`}
        customImageSrc="misc/edit-input-field.svg"
      />
    </div>
  )
}
